import DialogImport from './DialogImport'

export default DialogImport
